import React, { useEffect, useState } from "react";
import { Formik, Field, Form } from "formik";
import { loginFormDataSchema } from "../../PageComponent/ValidationSchema/LoginFormSchema";
import logoImage from "../../../Resources/images/ims.png";
import image from "../../../Resources/images/profile.png";
import cookie from "js-cookie";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../../../HOC/CreateAxios/CreateAxios";
function Login() {
  const navigate = useNavigate();
  const [visiblePassword, setVisiblePassword] = useState(false);

  const loginFormData = [
    {
      label: "Email",
      placeholder: "Email or Phone number",
      type: "email",
      apikey: "email",
    },
    {
      label: "password",
      placeholder: "Password ",
      type: "password",
      apikey: "password",
    },
  ];

  const Submit = (values) => {
    axios
      .post("/auth/login", values)
      .then((res) => {
        console.log(res.data.role);
        cookie.set("token", res.data.token);
        cookie.set("role", res.data.role);
        cookie.set("username", values.email);
        navigate("/");
      })
      .catch((err) => {
        console.log(err);
      });

    // console.log(values);
  };

  return (
    <div className="laptop:grid laptop:grid-cols-12">
      <div className="bg-pink-50 hidden laptop:flex   col-span-5  flex-col py-10 items-center  h-screen">
        <div className="w-32 ">
          <img src={logoImage} alt="loading ..." />
        </div>
        <div>
          <img src={image} alt="loading ..." />
        </div>
      </div>
      <div className="flex  flex-col col-span-7 justify-center h-screen laptop:h-full px-5 laptop:px-20 w-full ">
        <div className="font-semibold text-2xl  text-yellow-500 capitalize mb-1">
          {" "}
          {/* welcome to Dream Salon */}
          welcome to Inventory Management System
        </div>
        <div className="font-medium text-gray-400 text-sm  mb-4">
          {" "}
          {/* Beauty is in the eye of the beholder and the hands of your stylist. */}
          Our system is build for the management of products.
        </div>
        <div className=" w-full">
          <Formik
            initialValues={{ email: "", password: "" }}
            validationSchema={loginFormDataSchema}
            onSubmit={(values) => {
              console.log(values);
              Submit(values);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              /* and other goodies */
            }) => (
              <Form onSubmit={handleSubmit} className="laptop:w-11/12">
                <div className="  ">
                  {loginFormData.map((val, i) => {
                    return (
                      <div key={i}>
                        <div className="flex flex-col   mb-1 capitalize ">
                          <label
                            htmlFor={val.apikey}
                            className="cursor-pointer font-semibold"
                          >
                            {val.label}
                          </label>
                        </div>
                        <div className="relative">
                          <Field
                            type={
                              val.type === "password"
                                ? visiblePassword
                                  ? "text"
                                  : "password"
                                : val.type
                            }
                            name={val.apikey}
                            placeholder={val.placeholder}
                            className="bg-blue-50 bg-opacity-80 border-gray-400  w-full p-2 mt-1 rounded-sm"
                          />
                          {val.type === "password" && (
                            <div
                              onClick={() =>
                                setVisiblePassword(!visiblePassword)
                              }
                              className="absolute right-0.5 top-1.5"
                            >
                              <button className="bg-gray-200 p-2" type="button">
                                {visiblePassword ? (
                                  <AiFillEye className="text-xl" />
                                ) : (
                                  <AiFillEyeInvisible className="text-xl" />
                                )}
                              </button>
                            </div>
                          )}
                        </div>
                        <div
                          className={` ${
                            errors?.[val.apikey] && touched?.[val.apikey]
                              ? " bg-red-50 "
                              : ""
                          } text-sm p-1  text-red-500  my-2`}
                        >
                          {errors?.[val.apikey] && touched?.[val.apikey]
                            ? errors[val.apikey]
                            : ""}
                        </div>
                      </div>
                    );
                  })}
                </div>
                <button
                  type="submit"
                  className="bg-green-400 px-4 py-1 rounded-sm text-white font-semibold"
                >
                  Submit
                </button>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
}

export default Login;
